<button
  [ngClass]="{
    isSelected: type === FilterType.Chips || isSelected,
    isSelectedNoCheckmark: isSelected && !hasCheckmark,
  }"
  [attr.data-type]="type"
  [attr.data-viewport]="viewport"
  [disabled]="disabled"
  (click)="selectFilter()"
>
  {{ label }}
  <hdi-icon
    *ngIf="(type === FilterType.Chips || isSelected) && hasCheckmark"
    [iconName]="Icon()"
  ></hdi-icon>
</button>
